export enum CompanyAcnQuestion {
  VirtualOffice = "VIRTUAL_OFFICE",
  VirtualPlanSelect = "VIRTUAL_PLAN_SELECT",
  VirtualAddressSelect = "VIRTUAL_ADDRESS_SELECT",
  Occupier = "ACN_COMPANY_OCCUPIER",
  AsicAgentNomination = "ACN_ASIC_AGENT_NOMINATION",
}

export const COMPANY_ACN_FIELD_TO_PATH: Record<CompanyAcnQuestion, string> = {
  [CompanyAcnQuestion.VirtualOffice]: "virtual-office",
  [CompanyAcnQuestion.VirtualPlanSelect]: "virtual-plan-select",
  [CompanyAcnQuestion.VirtualAddressSelect]: "virtual-address-select",
  [CompanyAcnQuestion.Occupier]: "occupier",
  [CompanyAcnQuestion.AsicAgentNomination]: "asic-agent-nomination",
};
